<template>
  <div>
    <PageTitle>
      <b-container>
        <h1 class="display-3">Create a project</h1>
        <p class="lead">
          Fill in the form below to create a project. <br />
          The Project ID and Password serves as the log-in credentials of the
          consultant conducting the cost-benefit analysis. Please ensure you
          have recorded these log in credentials as there is no feature to
          recover them – they must be reset if forgotten.
        </p>
        <b-button
          variant="primary"
          href="/SINSW CBA Tool Input Template.xlsm"
          download
        >
          Download inputs template
        </b-button>
      </b-container>
    </PageTitle>
    <b-overlay :show="loading" rounded="sm" no-wrap fixed />
    <b-container>
      <ProjectForm :require_password="true" @onSubmit="submit($event)" />
    </b-container>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import ProjectForm from "@/components/ProjectForm.vue";

export default {
  name: "ProjectCreate",
  components: { PageTitle, ProjectForm },
  props: {},
  data() {
    return {
      error: false,
      loading: false,
    };
  },
  methods: {
    submit(event) {
      this.loading = true;
      this.error = false;
      if (event.password == event.confirm_password) {
        console.log(event);
        this.$store
          .dispatch("post", {
            data: event,
            url: "/project/create",
          })
          .then((response) => {
            this.loading = false;
            this.$router.push({
              name: "ProjectList",
              params: {
                id: response.data.public_id,
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            console.log(error.response.data);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.loading = false;
      }
    },
  },
  mounted() {
    if (!this.isAdmin) {
      this.$router.push({ name: "logout" });
    }
  },
  created() {},
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
};
</script>
